/** 海外首页 PC 首屏实际播放的 WebM 背景视频。 */
export const PC_BG_VIDEO_WEBM = 'https://roboneo-public.meitudata.com/public/roboneo-web-assets/main_bg_video_1920.webm';

/** 海外首页 PC 首屏在 WebM 不可用时回退的 MP4 背景视频。 */
export const PC_BG_VIDEO_MP4 = 'https://roboneo-public.meitudata.com/public/roboneo-web-assets/main_bg_video_1920.mp4';

/** 海外首页移动端通过 JSMpeg 绘制到 Canvas 的 TS 背景视频。 */
export const MOBILE_BG_VIDEO_TS = 'https://roboneo-public.meitudata.com/public/roboneo-web-assets/mobile_bg_video.ts';
